import { merge as baseMerge } from 'extend-merge';

export const merge = (state, newState) => baseMerge({}, state, newState);

export const getMonthName = (date) => {
  const formatter = new Intl.DateTimeFormat('ru', { month: 'long' });
  return formatter.format(Date.parse(date));
};
